import { createFileRoute, redirect } from '@tanstack/react-router';
import QualityPage from '../pages/QualityPage';
import { getProfileSync } from '../lib/getProfileSync';

export const Route = createFileRoute('/quality')({
  beforeLoad: () => {
    const profile = getProfileSync();
    if (!profile || profile.status !== 'active') {
      throw redirect({ to: '/' });
    }
    if (!['QualitySuper', 'Manager', 'Admin'].includes(profile.role)) {
      throw redirect({ to: '/' });
    }
  },
  component: QualityPage,
});
